export const DEMO_TOUR_SESSION_ID = 'onboarding-demo-tour';
